import { Button, Grid, MenuItem, Select, TextField, Typography } from "@material-ui/core";
import Utils from "~/helpers/Utils";
import checkoutServices from "~/services/checkoutServices";
import userUpdateService from "~/services/userUpdateService";
import { DialogBuilder } from "~/utils/DialogProvider";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import { getCountryCode as getIsoFromPrefix } from "~/helpers/countriesHelper";
import CountryDialCodeSelect from "~/components/common/CountryDialCodeSelect";

import useStyles from "./styles";

function PersonalInformationNumber(props) {
	const classes = useStyles();
	const dialog = useContext(DialogBuilder);
	const history = useHistory();
	const location = useLocation();

	const [phone, setPhone] = useState("");
	const [country, setCountry] = useState(null);
	const [loading, setLoading] = useState(false);
	const [ddiIndex, setPhoneDdiIndex] = useState(0);

	const logEventFor = location.state?.logEventFor;
	const returnRoute = location.state?.goBackRoute;

	const { i18n, t } = useTranslation();

	const { business } = useSelector((store) => store?.business);
	const storageLanguage = sessionStorage.getItem("@prit-web/language");
	const businessDdi = business?.phone && Utils.getCountryCodeFromPhone(business?.phone);
	const ddiSelected = Utils.ddis[ddiIndex]?.ddi;
	const language = storageLanguage ?? business?.language;

	const next = () => {
		history.replace(returnRoute);
	};

	const handleChangeType = (e) => {
		setPhoneDdiIndex(e.target.value);
	};

	const handleChange = (e) => {
		Utils.telephoneMask(e, Utils.ddis[ddiIndex].prefix);
		setPhone(e.target.value);
	};

	const submitForm = async () => {
		setLoading(true);

		let unmaskedPhone = phone.replace(/\D/g, "");
		unmaskedPhone = `${Utils.ddis[ddiIndex].ddi}${unmaskedPhone}`;

		try {
			await userUpdateService.pachUserUpdate(localStorage.getItem("@prit-web/userId"), {
				phoneUnverified: unmaskedPhone,
			});

			const res = await checkoutServices.me();

			if (res?.data?.id) {
				localStorage.setItem("@prit-web/meData", JSON.stringify(res.data));
				localStorage.setItem("@prit-web/userId", res.data.id);
			}

			next();
		} catch (error) {
			const errorMessage = error?.response?.data?.message || error.message;
			dialog.withMessage(`Houve um erro ao cadastrar seu número de telefone. ${errorMessage}`).show();
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (business?.phone) {
			const idx = Utils.phoneDdiIndex(business.phone);
			setPhoneDdiIndex(idx);
		} 
	}, [business?.phone]);

	useEffect(() => {
		if (business?.phone) {
			const current = Utils.ddis[ddiIndex];
			if (!current) return;
	
			const isoFromPrefix = getIsoFromPrefix(current.prefix);
			if (isoFromPrefix) {
				setCountry(isoFromPrefix.toUpperCase());
			} else {
				const ddiDigits = (current.ddi || "").replace(/\D/g, "");
				const match = getCountries().find((c) => String(getCountryCallingCode(c)) === ddiDigits);
				if (match) {
					setCountry(match.toUpperCase());
				}
			}
		}
	}, [ddiIndex]);

	return (
		<Grid container direction="column" spacing={3} style={{ width: "auto" }}>
			<Grid item xs={10}>
				<Typography style={{ margin: "5%" }} className={classes.title}>
					<strong>{t("Enter your number")}</strong>
				</Typography>
			</Grid>

			<Grid
				container
				item
				spacing={2}
				alignItems="center"
				style={{ paddingLeft: 20, paddingTop: 30, width: "inherit" }}>
				<Grid item>
					<CountryDialCodeSelect
						valueISO2={country}
						onChange={({ dialCode, iso2 }) => {
							setCountry(iso2);
							const foundIndex = Utils.ddis.findIndex((item) => item.ddi === dialCode);
							if (foundIndex !== -1) {
								setPhoneDdiIndex(foundIndex);
								setPhone("");
							}
						}}
						width={"100%"}
					/>
				</Grid>
				<Grid item xs>
					<TextField
						value={phone}
						onChange={(e) => {
							const ev = { target: { value: e.target.value } };
							const prefix = Utils.ddis[ddiIndex]?.prefix || Utils.ddis[0]?.prefix || "BRA";
							Utils.telephoneMask(ev, prefix);
							setPhone(ev.target.value);
						}}
						placeholder={t("Enter your phone")}
						fullWidth
						inputProps={{ maxLength: Utils.ddis[ddiIndex]?.pattern?.maxLength || 15 }}
						style={{ height: "44px" }}
						disabled={!ddiIndex && !country}
					/>
				</Grid>
				{( ddiIndex === -1 || !country) && (
					<Grid item xs={12} style={{ display: "flex", justifyContent: "center", paddingTop: 10 }}>
						<Typography
							style={{
								color: "#ff9800",
								fontSize: "0.875rem",
								fontStyle: "italic",
								textAlign: "center",
								maxWidth: "90%",
							}}>
							{t("Please select a country code")}
						</Typography>
					</Grid>
				)}
			</Grid>
			{business?.phone && businessDdi !== ddiSelected && (
				<Grid item xs={12} style={{ display: "flex", justifyContent: "center", paddingTop: 10 }}>
					<Typography
						style={{
							color: "#ff9800",
							fontSize: "0.875rem",
							fontStyle: "italic",
							textAlign: "center",
							maxWidth: "90%",
						}}>
						{t("Different country code warning")}
					</Typography>
				</Grid>
			)}
			<Grid item container style={{ paddingTop: 10, justifyContent: "center" }}>
				<Button
					className={classes.button}
					style={{
						backgroundColor:
							phone.replace(/\D/g, "").length < Utils.ddis[ddiIndex]?.maxLength ? "#dddddd" : "rgb(69 0 103)",
					}}
					onClick={submitForm}
					disabled={phone.replace(/\D/g, "").length < Utils.ddis[ddiIndex]?.maxLength}>
					{t("Go")}
				</Button>
			</Grid>
		</Grid>
	);
}

export default withRouter(PersonalInformationNumber);
